import { createContext as createReactRouterContext } from 'react-router';

/**
 * This context is created separate without importing the type to avoid
 * importing anything from a file with `import 'server-only'`.
 *
 * Giving us the guarantee during build-time that we're not leaking
 * anything from the server into the client.
 */
export const clientSafeServerRouterContext =
  // oxlint-disable-next-line typescript/no-explicit-any
  createReactRouterContext<any>();
